export default __webpack_public_path__ + "static/cabin-deluxe-2-to-3-2-7f8db97f714cc4e6fd331f388e2129a8.jpg";